
<!--
* A app button that triggers a file input click
*
* @param {Object} button - Object with properties to be used for button
* @param {string} button.state - State of button
* @param {string} button.type - Type of button
* @param {boolean} button.hasIconLeft - Whether button has icon on the left
* @param {boolean} button.hasIconRight - Whether button has icon on the right
* @param {string} button.text - Text of button
*
* @param {string} acceptedTypes - html 'accept' attributes, to filter input (images, audio..)
*
* @fires MsImageUpload#emitChange
-->

<!--
* Emits a change event.
*
* @event MsImageUpload#emitChange
-->

<template>
  <div class="file_input_button_wrapper">
    <app-button
      class="file_input_button"
      :state="button.state"
      :type="button.type"
      :hasIconLeft="button.hasIconLeft"
      :hasIconRight="button.hasIconRight"
      :text="$t(button.text)"
      @click.native="triggerFileInputClick"
    />
    <input
      type="file"
      class="file_input_button_input"
      ref="fileButtonInput"
      :accept="acceptedTypes"
      @change="emitChange"
      multiple />
  </div>
</template>

<script>
  import AppButton from '@/components/app-button'

  export default {
    name: 'MsFileInputButton',

    components: {
      AppButton
    },

    props: {
      button: {
        type: Object,
        required: true
      },

      acceptedTypes: {
        type: String,
        required: false,
        default: ''
      }
    },

    methods: {
      /**
       * Emit change event
       *
       * @param {Event} event - Event from file input change
       */
      emitChange: function (event) {
        this.$emit('change', event)
      },

      /**
       * Trigger click on file input to bring up file options
       */
      triggerFileInputClick: function () {
        this.$refs.fileButtonInput.click()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/sass/shared.scss";

  .file_input_button_wrapper {
    display: block;
    position: relative;
  }

  .file_input_button {
    z-index: 2;
    max-width: none;
    margin: $dims-spacing-xlarge auto 0 auto;
    padding: $dims-spacing-small 0;
  }

  // Hide the input field
  .file_input_button_input {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    pointer-events: none;
  }
</style>
